/* Web Speech narration for the guided tour. */
const synth = typeof window !== "undefined" ? window.speechSynthesis : null;
let current = null;

export const narrationSupported = () =>
  !!synth && typeof window.SpeechSynthesisUtterance !== "undefined";

function pickVoice() {
  const voices = synth.getVoices();
  const score = (v) => {
    const n = v.name.toLowerCase();
    let s = 0;
    if (v.lang.startsWith("en")) s += 10;
    if (v.lang === "en-GB") s += 5;
    if (/daniel|google uk english male|arthur|oliver/.test(n)) s += 8;
    if (/natural|neural|premium|enhanced/.test(n)) s += 3;
    return s;
  };
  return voices.slice().sort((a, b) => score(b) - score(a))[0] || null;
}

/* ~145 wpm at rate 0.92, plus a breath at the end */
export const estimateMs = (text) =>
  Math.round((text.trim().split(/\s+/).length / 2.4) * 1000 + 2500);

export function speak(text, { onEnd } = {}) {
  if (!narrationSupported()) return;
  stopSpeaking();
  const u = new window.SpeechSynthesisUtterance(text);
  u.voice = pickVoice();
  u.rate = 0.92;
  u.pitch = 0.88;
  u.volume = 1;
  const done = () => {
    if (current === u) {
      current = null;
      onEnd?.();
    }
  };
  u.onend = done;
  u.onerror = done;
  current = u;
  synth.speak(u);
}

export function stopSpeaking() {
  current = null;
  synth?.cancel();
}

export const pauseSpeaking = () => synth?.speaking && synth.pause();
export const resumeSpeaking = () => synth?.paused && synth.resume();
